<template>
  <v-menu
    ref="menu1"
    :close-on-content-click="false"
    v-model="menu1"
    :nudge-right="40"
    :return-value.sync="val"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      :value="dateFormatted"
      @input="onInput"
      :label="label"
      prepend-icon="event"
      readonly
      clearable
      :error="error"
      :error-messages="errorMessages"
    ></v-text-field>
    <v-date-picker
      :value="value"
      @input="onDPInput"
      no-title
      :type="month ? 'month' : 'date'"
      locale="pl">
    </v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    value: String,
    error: Boolean,
    label: String,
    month: Boolean,
    errorMessages: [String, Array]
  },
  data () {
    return {
      dateFormatted: this.formatDate(this.value),
      menu1: false,
      val: null
    }
  },
  watch: {
    value (val) {
      this.dateFormatted = this.formatDate(this.value)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('T')[0].split('-')
      if (day !== undefined) {
        return `${year}-${month}-${day}`
      } else {
        return `${year}-${month}`
      }
    },
    onInput (event) {
      if (!event) return null
      this.$emit('input', event.target.value)
    },
    onDPInput (val) {
      this.$refs.menu1.save(val)
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/InputDate.vue